const NAMESPACE = "hyperlink";

const KEYS = {
    linkNotConfiguredHelpText: "linkNotConfiguredHelpText"
};

const MESSAGES = {
    [KEYS.linkNotConfiguredHelpText]: {
        value: "(Hyperlink not configured; contact your program administrator)",
        comment: "Error message displayed when a link was not properly configured"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
